<template>
    <div class="max-w-xl mx-auto flex-col items-center">
        <div class="flex justify-center">
            <img
                :alt="$t('maintenance_modes.alt')"
                class="mb-10"
                src="/images/error/magnifying_glass.png"
            />
        </div>

        <h2
            class="style-h4 text-center"
            v-text="$t('maintenance_modes.title')"
        />

        <p
            v-if="message"
            class="text-center"
            v-text="message"
        />
        <p
            v-else
            class="text-center"
            v-html="$t('maintenance_modes.description')"
        />
    </div>
</template>

<script lang="ts" setup>
defineProps<{
    // Custom message of the maintenance mode, replaces the default description
    message?: string | null;
}>();
</script>
